import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrl;
const API_VERSION = environment.MSImagingProjectVersion;
const SERVICE = 'msimagingproject-dot-';
const requestURL = 'https://' + API_VERSION + SERVICE + API_URL;

@Injectable({
  providedIn: 'root'
})
export class SponsorService {

  constructor(private http: HttpClient) { }

  create(sponsor: any) {
    return this.http.post(requestURL + `/sponsor`, sponsor);
  }
  
  update(sponsor: any) {
    return this.http.put(requestURL + `/sponsor`, sponsor);
  }
  
  delete(id: number) {
    return this.http.delete(requestURL + `/sponsor/` + id);
  }

  getById(id: number) {
    return this.http.get(requestURL + `/sponsor/` + id);
  }
  
  getAll() {
    return this.http.get(requestURL + `/sponsor/retrieve-all`);
  }
}
